import React, { useState } from 'react';

export default function AdminProjects() {
  const [project, setProject] = useState({
    id: '',
    name: '',
    link: '',
    about: '',
    startDate: '',
    endDate: '',
    languages: [],
    image: null, // New image field
    imageName: ''
  });

  const handleLanguageNameChange = (e, index) => {
    const updatedLanguages = [...project.languages];
    updatedLanguages[index] = e.target.value;
    setProject((prevProject) => ({ ...prevProject, languages: updatedLanguages }));
  };

  const handleNumLanguagesChange = (e) => {
    const numLanguages = parseInt(e.target.value);
    setProject((prevProject) => ({
      ...prevProject,
      languages: Array.from({ length: numLanguages }, (_, index) => prevProject.languages[index] || ''),
    }));
  };

  const handleInputs = (e) => {
    const { name, value } = e.target;
    setProject((prevProject) => ({ ...prevProject, [name]: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setProject((prevProject) => ({
      ...prevProject,
      image: file,
      imageName: file.name // Set the imageName to the filename of the uploaded image
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { id, name, link, about, startDate, endDate, languages, image,imageName } = project;

    const formData = new FormData();
    formData.append('id', id);
    formData.append('name', name); 
    formData.append('link', link);
    formData.append('about', about);
    formData.append('startDate', startDate);
    formData.append('endDate', endDate);
    formData.append('languages', JSON.stringify(languages));
    formData.append('image', image); // Append the image file to the form data
    formData.append('imageName', imageName); // Append the image file to the form data

    const res = await fetch('/admin/projects', {
      method: 'POST',
      mode: 'cors',
      body: formData,
    });

    const data = await res.json();
    console.log(data);

    if (data.status === 422 || !data) {
      window.alert('Project entry failed');
      console.log('Project entry failed');
    } else if (data.status === 200 || data) {
      window.alert('Project entry successful');
      console.log('Project entry successful');
    }
  };

  return (
    <div className="admin-projects">
      <form onSubmit={handleSubmit} className="project-form">
        <input type="number" name="id" placeholder="ID" value={project.id} onChange={handleInputs} />

        <input type="text" name="name" placeholder="Name" value={project.name} onChange={handleInputs} />

        <input type="text" name="link" placeholder="Link" value={project.link} onChange={handleInputs} />

        <input type="text" name="about" placeholder="About" value={project.about} onChange={handleInputs} />

        <input
          type="date"
          name="startDate"
          placeholder="StartDate"
          value={project.startDate}
          onChange={handleInputs}
        />

        <input
          type="date"
          name="endDate"
          placeholder="EndDate"
          value={project.endDate}
          onChange={handleInputs}
        />

        {/* <input type="text" name = "imageName" value={project.imageName} onChange={handleInputs} placeholder='Imagename'/> */}

        <input
          type="number"
          name="languages"
          placeholder="Languages"
          value={project.languages.length}
          onChange={handleNumLanguagesChange}
        />

        {Array.from({ length: project.languages.length }, (_, index) => (
          <input
            key={index}
            type="text"
            placeholder={`Language ${index + 1}`}
            value={project.languages[index] || ''}
            onChange={(e) => handleLanguageNameChange(e, index)}
          />
        ))}

        <input type="file" name="image" onChange={handleImageUpload} /> {/* Add the image input */}

        

        <button type="submit">Submit</button>
      </form>
    </div>
  );
}
